import React, { useEffect, useState } from "react";
import feather from "feather-icons";
import { ethers } from "ethers";

// === Environment Variables (.env)
const TOKEN_SYMBOL = process.env.REACT_APP_TOKEN_SYMBOL || "NEXORA";
const TOKEN_ADDRESS = process.env.REACT_APP_TOKEN_ADDRESS;
const QUICKSWAP_URL = process.env.REACT_APP_QUICKSWAP_URL;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;


export default function Buy() {
  const [wallet, setWallet] = useState(null);
  const [priceUSD, setPriceUSD] = useState(null);
  const [pricePOL, setPricePOL] = useState(null);
  const [loading, setLoading] = useState(true);
  const [amount, setAmount] = useState("");
  const [tokenAmount, setTokenAmount] = useState(0);

  // === Connexion MetaMask ===
  const connectWallet = async () => {
    if (!window.ethereum) return alert("🦊 Please install MetaMask!");
    try {
      const provider = new ethers.BrowserProvider(window.ethereum);
      await provider.send("eth_requestAccounts", []);
      const signer = await provider.getSigner();
      const address = await signer.getAddress();
      setWallet(address);
      localStorage.setItem("wallet-address", address);
    } catch (err) {
      console.error(err);
      alert("Connection failed. Try again.");
    }
  };

  // === Auto-connexion au lancement ===
  useEffect(() => {
    setTimeout(() => feather.replace(), 150);
    if (window.ethereum) {
      window.ethereum.request({ method: "eth_accounts" }).then((accounts) => {
        if (accounts.length > 0) setWallet(accounts[0]);
      });
    }
  }, []);

  // === Récupération du prix en temps réel (DexScreener) ===
  useEffect(() => {
    const fetchPrice = async () => {
      try {
        const res = await fetch(`https://api.dexscreener.com/latest/dex/tokens/${TOKEN_ADDRESS}`);
        const data = await res.json();

        if (data.pairs && data.pairs.length > 0) {
          const pair = data.pairs[0];
          setPriceUSD(parseFloat(pair.priceUsd));
          if (pair.priceNative) setPricePOL(parseFloat(pair.priceNative));
        } else {
          console.warn("No live price data found for", TOKEN_SYMBOL);
          setPriceUSD(0.000);
          setPricePOL(0.000001);
        }
      } catch (err) {
        console.error("Error fetching price:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPrice();
    const interval = setInterval(fetchPrice, 30000); // refresh 30s
    return () => clearInterval(interval);
  }, []);

  // === Calcul du montant à recevoir ===
  useEffect(() => {
    if (!priceUSD) return;
    const amt = parseFloat(amount) || 0;
    setTokenAmount(priceUSD ? amt / priceUSD : 0);
  }, [amount, priceUSD]);

  // === Simulation Achat ===
  const handleBuy = () => {
    if (!wallet) return alert("Connect your wallet first!");
    const parsed = parseFloat(amount);
    if (!parsed || parsed <= 0) return alert("Enter a valid amount to simulate.");
    const toReceive = priceUSD ? parsed / priceUSD : 0;
    alert(
      `🪙 Simulated purchase:\n${toReceive.toLocaleString()} ${TOKEN_SYMBOL}\nusing ${parsed} USDC`
    );
  };

  const shortAddress = wallet ? `${wallet.slice(0, 6)}...${wallet.slice(-4)}` : "Connect Wallet";

  // === Rendu UI ===
  return (
    <div className="text-white py-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="bg-gray-900 bg-opacity-70 rounded-2xl p-10 border border-neonPurple/40 shadow-lg hover:border-neonPink/50 transition-all">
          <h1 className="text-4xl font-extrabold mb-10 text-center bg-gradient-to-r from-neonPink to-neonBlue bg-clip-text text-transparent">
            Buy {TOKEN_SYMBOL} Tokens
          </h1>

          {/* === Prix du token === */}
          <div className="bg-gray-800 rounded-xl p-6 border border-neonBlue/30 mb-10 shadow-inner">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold text-neonBlue">{TOKEN_SYMBOL} Live Market Price</h2>
              {loading ? (
                <span className="text-gray-400 animate-pulse">Loading...</span>
              ) : (
                <span className="text-sm text-gray-400">Auto-refresh 30s</span>
              )}
            </div>
            <div className="grid md:grid-cols-2 gap-6 text-center">
              <div className="p-4 bg-gray-900 rounded-lg border border-gray-700 hover:border-neonPink transition-all">
                <p className="text-sm text-gray-400 mb-2">1 {TOKEN_SYMBOL} =</p>
                <h3 className="text-3xl font-bold text-neonPink">
                  {priceUSD ? `$${priceUSD.toFixed(6)}` : "—"}
                </h3>
                <p className="text-xs text-gray-500 mt-1">in USDC</p>
              </div>
              <div className="p-4 bg-gray-900 rounded-lg border border-gray-700 hover:border-neonBlue transition-all">
                <p className="text-sm text-gray-400 mb-2">1 {TOKEN_SYMBOL} =</p>
                <h3 className="text-3xl font-bold text-neonBlue">
                  {pricePOL ? `${pricePOL.toFixed(8)} POL` : "—"}
                </h3>
                <p className="text-xs text-gray-500 mt-1">in POL</p>
              </div>
            </div>
          </div>

          {/* === Simulation d’achat === */}
          <div className="mb-8">
            <label className="block text-sm font-medium mb-3 text-neonPink uppercase tracking-wide">
              Amount (in USDC)
            </label>
            <div className="relative">
              <input
                type="number"
                className="w-full bg-gray-800 border border-neonPurple/40 rounded-lg px-4 py-3 text-lg focus:ring-2 focus:ring-neonPink outline-none transition"
                placeholder="0.00"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
              <div className="absolute right-3 top-2 flex items-center gap-2">
                <span className="text-sm text-gray-400">USDC</span>
                <button
                  onClick={() => setAmount("1000")}
                  className="text-xs bg-gradient-to-r from-neonPurple to-neonPink px-2 py-1 rounded text-white hover:opacity-90"
                >
                  MAX
                </button>
              </div>
            </div>
          </div>

          {/* === Résumé === */}
          <div className="p-5 mb-8 bg-gray-800 rounded-xl border border-neonPurple/30">
            <div className="flex justify-between mb-2 text-sm text-gray-400">
              <span>You will receive:</span>
              <span className="text-neonBlue font-semibold">
                {tokenAmount.toLocaleString()} {TOKEN_SYMBOL}
              </span>
            </div>
            <div className="flex justify-between text-sm text-gray-400">
              <span>Current Price:</span>
              <span className="text-neonPink font-medium">
                ${priceUSD ? priceUSD.toFixed(6) : "—"} / {TOKEN_SYMBOL}
              </span>
            </div>
          </div>

          {/* === Boutons === */}
          <div className="flex flex-col md:flex-row gap-4">
            <button
              onClick={wallet ? handleBuy : connectWallet}
              className="flex-1 py-4 bg-gradient-to-r from-neonPurple to-neonPink rounded-xl text-lg font-bold hover:opacity-90 transition-all shadow-md"
            >
              {wallet ? "Simulate Buy" : "Connect Wallet"}
            </button>

            <a
              href={QUICKSWAP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 text-center py-4 bg-gradient-to-r from-neonBlue to-neonPurple rounded-xl text-lg font-bold hover:opacity-90 transition-all shadow-md"
            >
              Swap on QuickSwap
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
